module.exports = __webpack_public_path__ + "img/look.1d9a8e6a.svg";